import axios from 'axios';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${API_BASE}/api`;

// App version — keep in sync with android/app/build.gradle versionName
// and backend MIN_APP_VERSION. All older APKs/PWAs will be rejected by
// the backend with HTTP 426.
// At 2.1.2 (build 30) — ships the Phase 78ag–78av batch (multi-stop
// refinements, drag-reorder, route optimiser + preview, WhatsApp dedup
// + group toggles + send-stats, master-driven Add-Stop dialog, camera
// auto-resize, new multi-stop pilot screen, geofence-locked Done
// buttons, Google lifecycle timestamps, Supplier Coord Health + map
// preview).
export const APP_VERSION = '2.1.2';

const api = axios.create({
  baseURL: API,
  // No `withCredentials` — we authenticate via JWT in the Authorization header,
  // not cookies. Turning this on would require an explicit CORS origin (no wildcard),
  // and caused a silent browser-side rejection even on 200 OK responses on
  // production (April 22, 2026 login regression).
  headers: { 'Content-Type': 'application/json', 'X-App-Version': APP_VERSION }
});

// Add token from localStorage as fallback
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Always advertise the app version so the backend can reject stale APKs.
  config.headers['X-App-Version'] = APP_VERSION;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      // Don't bounce away from public landing pages. Phase 76q — `/track/*`
      // is the public trip-track page linked from WhatsApp; outside
      // recipients have no auth and must NOT be redirected to login.
      const path = window.location.pathname;
      const isPublic = path === '/login' || path === '/upgrade' || path.startsWith('/track/');
      if (!isPublic) {
        window.location.href = '/login';
      }
    }
    // 426 Upgrade Required → old APK is locked out; redirect to a hard
    // upgrade screen so the user knows they have to reinstall.
    if (err.response?.status === 426) {
      const path = window.location.pathname;
      if (path !== '/upgrade' && !path.startsWith('/track/')) {
        window.location.href = '/upgrade';
      }
    }
    return Promise.reject(err);
  }
);

export default api;
export { API_BASE, API };
